import React, { useState, useEffect } from "react";
import { Button, Col, FormGroup, Modal, Row, Container } from "react-bootstrap";
import { Form, Input, Select } from 'antd';
import { ImageElement, LoginHeader } from "../../components";
import { Link } from "react-router-dom";
const handleChange = (value) => {
    console.log(`selected ${value}`);
};


function Dashboard() {


    // modal

    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    const [plumbing, setplumbing] = useState(false);
    const plumbingClose = () => setplumbing(false);
    const plumbingShow = () => setplumbing(true);
    useEffect(() => {
        const svgFunction = () => {
            document.querySelectorAll('img.svg').forEach((el) => {
                console.log(el)
                const imgID = el.getAttribute('id');
                const imgClass = el.getAttribute('class');
                const imgURL = el.getAttribute('src');
        
                fetch(imgURL)
                    .then(data => data.text())
                    .then(response => {
                        const parser = new DOMParser();
                        const xmlDoc = parser.parseFromString(response, 'text/html');
                        let svg = xmlDoc.querySelector('svg');
                        if (typeof imgID !== 'undefined') {
                            svg.setAttribute('id', imgID);
                        }
                        if (typeof imgClass !== 'undefined') {
                            svg.setAttribute('class', imgClass + ' replaced-svg');
                        }
                        svg.removeAttribute('xmlns:a');
                        el.parentNode.replaceChild(svg, el);
                    })
            });
        }
        svgFunction();
    }, [])
    
   

    return (
        <>
            <LoginHeader />
            <div className="main-content dashboardPage">
                {/* page content */}
                <div className="pageContent">
                    <Container className="container-lg">
                        {/* your address */}
                        <div className="yourAddress bg-white">
                            <h2 className="font-sm">Let’s confirm your address</h2>
                            <p className="mb-0">Select and confirm your service address or add a new address</p>
                            <div className="d-flex align-items-center">
                                <Form className="w-100">
                                    <FormGroup className="form-group mb-0 d-flex align-items-center flex-wrap">
                                        <div className="position-relative yourAddress_form">
                                            <em className="gg-marker" />
                                            <Select
                                                defaultValue="address1"
                                                onChange={handleChange}
                                                className="w-100"
                                                options={[
                                                    {
                                                        value: 'address2',
                                                        label: 'Gita Bhawan',
                                                    },
                                                    {
                                                        value: 'address1',
                                                        label: 'Vijay Nagar Square, Vijay Nagar, Indore, Madhya Pradesh, India',
                                                    }
                                                ]}
                                            />
                                        </div>
                                        <Button variant="info" size="lg" type="submit" onClick={handleShow} className="ms-lg-4 ms-md-2  mt-md-0 mt-2  font-sm">Add location</Button>
                                    </FormGroup>
                                </Form>
                            </div>
                        </div>
                        {/* service address */}
                        <div className="serviceAddress bg-white">
                            <h2 className="font-sm mb-mb-2 mb-1">Service Address</h2>
                            <p className="mb-0 font-md">Vijay Nagar Square, Vijay Nagar, Indore, Madhya Pradesh, India</p>
                        </div>
                        {/* service type */}

                        {/* EMPTY SCREEN_______ */}
                        <div className="serviceType">
                            <h2 className="font-sm mb-md-4 mb-3">What type of service would you like?</h2>
                            {/* <div className="noList m-auto text-center d-flex align-items-center justify-content-center">
                                <div className="noList_inner">
                                    <ImageElement source="no-provider.svg" className="img-fluid"/>
                                    <div className="noList_cnt">
                                        <h5>Service Provider Not Found</h5>
                                        <p className="mb-0">Lorem Ipsum is simply dummy text of the printing and typesetting industry.</p>
                                    </div>
                                </div>                                
                            </div> */}
                            <Row className="row row-cols-xxl-6  row-cols-lg-4 row-cols-sm-3 row-cols-2 g-xl-4 g-lg-3 g-2">

                                <Col>
                                    <div className="type">
                                        <div className="type_wrap bg-white rounded d-flex align-items-center justify-content-center flex-column">
                                            <ImageElement className="svg" source="hvac.svg" />
                                            <h3 className="font-md mb-0 d-flex align-items-center">HVAC
                                                <Link to="#" onClick={plumbingShow} ><em className="gg-info" /></Link>
                                            </h3>
                                        </div>
                                        <Link to="/service-detail" className="type_link"></Link>
                                    </div>

                                </Col>
                                <Col>
                                    <div className="type">
                                        <div className="type_wrap bg-white rounded d-flex align-items-center justify-content-center flex-column">
                                            <ImageElement className="svg" source="call-booking.svg" />
                                            <h3 className="font-md mb-0 d-flex align-items-center">Call Booking
                                                <Link to="#" onClick={plumbingShow} ><em className="gg-info" /></Link>
                                            </h3>
                                        </div>
                                        <Link to="/qanca" className="type_link"></Link>
                                    </div>
                                </Col>
                                <Col>
                                    <div className="type">
                                        <div className="type_wrap bg-white rounded d-flex align-items-center justify-content-center flex-column">
                                            <ImageElement className="svg" source="category.svg" />
                                            <h3 className="font-md mb-0 d-flex align-items-center">Category
                                                <Link to="#" onClick={plumbingShow} ><em className="gg-info" /></Link>
                                            </h3>
                                        </div>
                                        <Link to="/service-detail" className="type_link"></Link>
                                    </div>
                                </Col>
                                <Col>
                                    <div className="type">
                                        <div className="type_wrap bg-white rounded d-flex align-items-center justify-content-center flex-column">
                                            <ImageElement className="svg" source="electrician.svg" />
                                            <h3 className="font-md mb-0 d-flex align-items-center">Electrician
                                                <Link to="#" onClick={plumbingShow} ><em className="gg-info" /></Link>
                                            </h3>
                                        </div>
                                        <Link to="/service-detail" className="type_link"></Link>
                                    </div>
                                </Col>
                                <Col>
                                    <div className="type">
                                        <div className="type_wrap bg-white rounded d-flex align-items-center justify-content-center flex-column">
                                            <ImageElement className="svg" source="plumbing.svg" />
                                            <h3 className="font-md mb-0 d-flex align-items-center">Plumbing
                                                <Link to="#" onClick={plumbingShow} ><em className="gg-info" /></Link>
                                            </h3>
                                        </div>
                                        <Link to="/service-detail" className="type_link"></Link>
                                    </div>
                                </Col>
                                <Col>
                                    <div className="type">
                                        <div className="type_wrap bg-white rounded d-flex align-items-center justify-content-center flex-column">
                                            <ImageElement className="svg" source="handyman.svg" />
                                            <h3 className="font-md mb-0 d-flex align-items-center">Handyman
                                                <Link to="#" onClick={plumbingShow} ><em className="gg-info" /></Link>
                                            </h3>
                                        </div>
                                        <Link to="/service-detail" className="type_link"></Link>
                                    </div>
                                </Col>
                                <Col>
                                    <div className="type">
                                        <div className="type_wrap bg-white rounded d-flex align-items-center justify-content-center flex-column">
                                            <ImageElement className="svg" source="qacategory.svg" />
                                            <h3 className="font-md mb-0 d-flex align-items-center">QA & Category
                                                <Link to="#" onClick={plumbingShow} ><em className="gg-info" /></Link>
                                            </h3>
                                        </div>
                                        <Link to="/service-detail" className="type_link"></Link>
                                    </div>
                                </Col>
                                <Col>
                                    <div className="type">
                                        <div className="type_wrap bg-white rounded d-flex align-items-center justify-content-center flex-column">
                                            <ImageElement className="svg" source="roofing.svg" />
                                            <h3 className="font-md mb-0 d-flex align-items-center">Roofing
                                                <Link to="#" onClick={plumbingShow} ><em className="gg-info" /></Link>
                                            </h3>
                                        </div>
                                        <Link to="/service-detail" className="type_link"></Link>
                                    </div>
                                </Col>
                                <Col>
                                    <div className="type">
                                        <div className="type_wrap bg-white rounded d-flex align-items-center justify-content-center flex-column">
                                            <ImageElement className="svg" source="satellite.svg" />
                                            <h3 className="font-md mb-0 d-flex align-items-center">Satellite
                                                <Link to="#" onClick={plumbingShow} ><em className="gg-info" /></Link>
                                            </h3>
                                        </div>
                                        <Link to="/service-detail" className="type_link"></Link>
                                    </div>
                                </Col>
                                <Col>
                                    <div className="type">
                                        <div className="type_wrap bg-white rounded d-flex align-items-center justify-content-center flex-column">
                                            <ImageElement className="svg" source="home-shield.svg" />
                                            <h3 className="font-md mb-0 d-flex align-items-center">American Home Shield
                                                <Link to="#" onClick={plumbingShow} ><em className="gg-info" /></Link>
                                            </h3>
                                        </div>
                                        <Link to="/service-detail" className="type_link"></Link>
                                    </div>
                                </Col>
                            </Row>
                        </div>
                    </Container>
                </div>
            </div>
            {/* add location */}
            <Modal show={show} onHide={handleClose} size="lg" centered id="addLocation" className="addLocation" backdrop="static">
                <Modal.Header closeButton className="align-items-start pb-0">
                    <div>
                        <Modal.Title>Add Location</Modal.Title>

                    </div>
                </Modal.Header>
                <Modal.Body>
                    <Form>
                        <h6 className="subTitle">Service Address</h6>
                        <FormGroup className="form-group">
                            <label className="ant-label">Address Line 1 <span className="text-650">*</span></label>
                            <Input size="large" placeholder="Address Line 1" required />
                        </FormGroup>
                        <Row>
                            <Col sm={6}>
                                <FormGroup className="form-group">
                                    <label className="ant-label">Name</label>
                                    <Input size="large" />
                                </FormGroup>
                            </Col>
                            <Col sm={6}>
                                <FormGroup className="form-group">
                                    <label className="ant-label">Address Line 2</label>
                                    <Input size="large" />
                                </FormGroup>
                                {/* <FormGroup className="form-group">
                                    <Input size="large" placeholder="Last Name*" />
                                    <label className="ant-label">Last Name<span className="text-650">*</span></label>
                                </FormGroup> */}
                            </Col>
                            <Col sm={6}>
                                <FormGroup className="form-group">
                                    <label className="ant-label">Suite Number</label>
                                    <Input size="large" />
                                </FormGroup>
                            </Col>
                            <Col sm={6}>
                                <FormGroup className="form-group">
                                    <label className="ant-label">State<span className="text-650">*</span></label>
                                    <Input size="large" required/>
                                </FormGroup>
                            </Col>
                            <Col sm={6}>
                                <FormGroup className="form-group mb-3 mb-sm-0">
                                    <label className="ant-label">City<span className="text-650">*</span></label>
                                    <Input size="large"  required/>
                                </FormGroup>
                            </Col>
                            <Col sm={6}>
                                <FormGroup className="form-group mb-0">
                                    <label className="ant-label">Zip Code</label>
                                    <Input size="large"  />
                                </FormGroup>
                            </Col>
                        </Row>
                        <Button variant="primary" className="mt-3 mt-sm-4 ms-auto min-200">Save</Button>
                    </Form>
                </Modal.Body>
            </Modal>

            {/* Paid- Emergency */}
            <Modal show={plumbing} onHide={plumbingClose} size="lg" centered id="Emergency" className="Emergencymodel" backdrop="static">
                <Modal.Header closeButton className="align-items-start justify-content-center">
                    <div>
                        <Modal.Title>Plumbing</Modal.Title>
                    </div>
                </Modal.Header>
                <Modal.Body>
                    <div className="text-center">
                        <p className="mb-0"> A plumber is tradesperson who specializes in installing and maintaining systems used for potable (drinking) water, sewage and drainage in plumbing systems.</p>
                    </div>
                </Modal.Body>
            </Modal>
        </>
    );
}

export default Dashboard;